import * as React from 'react'
import Main from '../Components/Main'
import Persistence from '../Components/Persistence'
import ScheduleDay from '../Components/Schedule/ScheduleDay'
import AddScheduleForm from '../Components/Form/AddScheduleForm'
import { Calendar as CalendarMonth } from '../Components/Schedule/Calendar'
import Modal from '../Components/Modal'

import { Calendar as CalendarIcon, Schedule as ScheduleIcon } from "../Components/Icons"

import * as m from 'moment'
import * as _ from 'lodash'

import { T, C } from '@homeschooling/sdk'

//import { MultiSelect } from 'primereact/multiselect'

import { DatePicker } from '../Components/Common'
import { Fetch } from '../Components/Networking'

//import ScheduleDay from '../Components/Schedule/ScheduleDay'

import SDKFactory from '../Components/SDKFactory'
import { v4 as uuid } from 'uuid';

Persistence.setValues()

interface Props { }

interface Form {
    [key: string]: string
  }

interface State {
    isLoading: boolean,
    schedule: T.ScheduleDay[]
    students: T.Student[]
    subjects: C.ConstantKey[]
    selectedStudents: T.Student[]
    selectedSubjects: C.ConstantKey[]
    timePeriod: string
    display: string
    startDate: any
    endDate: any
    showAdd: boolean
    showAddNote: boolean
    form: Form
    errors: {[key: string]: string}
    eventEvent: T.Schedule | undefined
    eventDay: string
    showDatesMenu: boolean
    showStartDate: boolean
    showEndDate: boolean
    scheduleHash: string
}

export class Schedule extends React.Component<Props, State> {

    private sdk = SDKFactory.getScheduleSDK()
    private wrapperRef = React.createRef<HTMLInputElement>();
    
    //private noteSdk = SDKFactory.getNotesSDK()

    public constructor (props: Props) {
        super(props)
    
        const start = m()
        const remainder = 15 - (start.minute() % 15);
        const startTime = m(start)
            .add(remainder, "minutes")
            .format("H:mm");

        const endTime = m(start)
            .add(remainder, "minutes")
            .add(1, 'hour')
            .format("H:mm");

        let startDate = m().startOf('month').format()
        let endDate = m(startDate).endOf('month').format('YYYY-MM-DD')
        startDate = m(startDate).startOf('week').format('YYYY-MM-DD')
        endDate = m(endDate).endOf('week').format('YYYY-MM-DD')   

        this.state = {
          isLoading: true,
          schedule: [],
          subjects: this.makeArrayFromObject(C.subject),
          students: Persistence.getStudents(),
          selectedStudents: Persistence.getStudents(),
          selectedSubjects: this.makeArrayFromObject(C.subject),
          timePeriod: 'monthly',
          display: 'monthly',
          startDate: startDate,
          endDate: endDate,
          showAdd: false,
          showAddNote: false,
          form: {
            'startDate': m().format(),
            'endDate': m().add(1, 'month').format(),
            'startTime': startTime,
            'endTime': endTime
          },
          errors: {},
          eventEvent: undefined,
          eventDay: m().format('YYYY-MM-DD'),
          showDatesMenu: false,
            showStartDate: false,
            showEndDate: false,
            scheduleHash: uuid()
        }

        this.handleClickOutside = this.handleClickOutside.bind(this);

      }

    public async componentDidMount() {

        document.addEventListener("mousedown", this.handleClickOutside);
        
       /* try {
            this.getSchedule()
          } catch (reason) {
            console.log(this.sdk)
            console.log('Error getting user dash', reason)
          }  */
    }


    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }

    handleClickOutside(event: any) {
        if (this.wrapperRef && !this.wrapperRef?.current?.contains(event.target)) {
            if (this.state.showDatesMenu || this.state.showStartDate || this.state.showEndDate) {
                this.setState({ showDatesMenu: false, showStartDate: false, showEndDate: false })
            }
        }
    }

    public toggleAddEvent = async () => {
       
    this.setState({showAdd: !this.state.showAdd})
    }
    
    public updateSchedule = (data: T.ScheduleDay[]) => {
        this.setState({
            scheduleHash: uuid()
        })
    }

    public updateNoteInPlace (note: T.Progress){
        
       /* let schedule = this.state.schedule

        let indexOfDay =  _.findIndex(schedule, {date: m(note.date).format('YYYY-MM-DD')})
        
        let events = schedule[indexOfDay].events
        let indexOfEvent = _.findIndex(events, {id: note.schedule_id})

        schedule[indexOfDay].events[indexOfEvent].notes.push(note)
        
        this.setState({schedule})*/
        this.setState({
            scheduleHash: uuid()
        })
    }

    public updateExpenseInPlace (expense: T.Expense){
        
        /*let schedule = this.state.schedule
        
        for(let s of schedule){
            let dayIndex = schedule.indexOf(s)
            let eventIndex = _.findIndex(s.events, {id: expense.schedule_id})
            if(dayIndex >= 0 && eventIndex >= 0){
                schedule[dayIndex].events[eventIndex].expenses.push(expense)
            }
        }

        this.setState({schedule})*/
         this.setState({
            scheduleHash: uuid()
        })
    }

    public addNote = async (note?: Form) => {
        //let { form } = this.state

        //form = note ? note : form

        //return await this.addScheduleNote(form)
    }

    public toggleAddNote = async (day: string, event?: T.Schedule) => {
       
        this.setState({showAddNote: !this.state.showAddNote, eventEvent: event, eventDay: day})
    }

    public updateDateRange = async (start_date: string, end_date: string, event_day: string) => {
        this.setState({startDate: start_date, endDate: end_date, eventDay: event_day, scheduleHash: uuid()})
        //await this.getSchedule(start_date, end_date)
    }

    public getSchedule = async (start_date?: string, end_date?: string) => {
        try {

            start_date = start_date ? start_date : m(this.state.startDate).format('YYYY-MM-DD')
            end_date = end_date ? end_date : m(this.state.endDate).format('YYYY-MM-DD')

            const res = await this.sdk
              .getFamilySchedule(start_date, end_date)
  
              let sche = res.data
              const hasError: boolean = _.get(res, 'error', false) as boolean

              if(!hasError){
                let data = sche as T.ScheduleDay[]
                this.setState({
                    schedule: data,
                    startDate: start_date,
                    endDate: end_date,
                    display: this.state.timePeriod,
                    isLoading: false
                })
              }
          } catch (reason) {
            console.log('Error getting user dash', reason)
          }  
    }

    
    public makeSchedule = (data: T.ScheduleDay[]) => {
        if(this.state.display === 'daily'){
            return this.makeDailySchedule()
        } else {
            return this.makeMonthlySchedule(data)  
        }
    }

    public toggleTimePeriod = () => {

        if(this.state.timePeriod === 'daily') {
            let start = m(this.state.startDate).startOf('month').format()
            let end = m(start).endOf('month').format('YYYY-MM-DD')
            start = m(start).startOf('week').format('YYYY-MM-DD')
            end = m(end).endOf('week').format()
            this.setState({timePeriod: 'monthly',
                startDate: start,
                endDate: end
            })
        } else {
            this.setState({timePeriod: 'daily',
                startDate: m().format('YYYY-MM-DD'),
                endDate: m().add(6, 'days').format('YYYY-MM-DD')
            })
        }
    }

    public makeMonthlySchedule = (data: T.ScheduleDay[]) => {

        return(<CalendarMonth 
            updateCal={async (start, end, focus) => await this.updateDateRange(start, end, focus)}
            start_date={this.state.startDate} 
            end_date={this.state.endDate} 
            schedule={data}
            updateNote={(note: T.Progress) => this.updateNoteInPlace(note)} 
            updateExpense={(expense: T.Expense) => this.updateExpenseInPlace(expense)}
            focus={this.state.eventDay}
            />)
    }

    public makeDailySchedule = () => {
        let schedule: T.ScheduleDay[] = this.state.schedule

        let display = []

        for(let s of schedule){
            display.push(<ScheduleDay schedule={s}  
                showDate={true} 
                updateSchedule={() => console.log('Update later')}
                updateNote={() => console.log('Update late')} 
                updateExpense={() => console.log('Update late')}/>)
        }
        
        return (
        <div className='w-full grid gap-1 grid-cols-7'>
            {display}
        </div>
        )
    }

    public setDate = (e: any) => {
        let startDate = this.state.startDate
        let endDate = this.state.endDate
        let dates = e as Date[]
        let date = dates[0]
        if (m(date).isBefore(endDate)) {
            startDate = m(date).format('YYYY-MM-DD')
        } else {
            endDate = m(date).format('YYYY-MM-DD')
        }

        this.setState({
            startDate: startDate,
            endDate: endDate
        })
    }

    public makeArrayFromObject = (obj: any) => {
        let array = Object.keys(obj).map(key => {
            return obj[key]
        })

        return array

    }
    
    public getAddForm = () => {

        return(<AddScheduleForm
                closeForm={this.toggleAddEvent}
                inPlaceUpdate={this.updateSchedule}
                form={{}}
                errors={{}}
                startDate={this.state.startDate}
                endDate={this.state.endDate}
            />
        )
    }

    public setDay = (key: string, date: string) => {
        let update = {
            ...this.state,
            startDate: m(date).startOf('month').startOf('week').format('YYYY-MM-DD'),
            eventDay: m(date).startOf('month').format('YYYY-MM-DD'),
            endDate: m(date).endOf('month').endOf('week').format('YYYY-MM-DD'),
            showStartDate: false
        }
        this.setState(update)
    }

    public render () {

    const { startDate, endDate, scheduleHash } = this.state    

    let students = 'all'

    const requestHash = JSON.stringify({ scheduleHash, startDate, endDate })

    return (
        <div className='w-full h-full'>
            <Modal
        open={this.state.showAdd}
        onClose={this.toggleAddEvent}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        {this.getAddForm()}
      </Modal>
            
            <Main>
                <div className='m-10'>
                    <div className='w-full flex-none pb-5'>
                        <h1 className='w-full flex flex-rows content-center'>
                            <div className='flex none'>
                                <ScheduleIcon
                                size='large'
                                className='fill-gray-900'
                            />
                            </div>
                            <div className='flex flex-grow text-3xl font-semibold '>
                                Schedule    
                            </div>
                        </h1>
                    </div>
                    <div className='w-full flex flex-col h-auto border-b'>
                                                <div className='w-full flex items-end sm:items-center flex-col py-2 sm:py-0 sm:flex-row gap-4'>
                                                    <div className='w-auto grow'></div>
                    
                                                    {/*<div className='w-48 flex-none'>     
                                                                <MultiSelect value={this.state.selectedStudents} onChange={(e) => this.handleSelectStudent(e.value)} options={this.state.students} optionLabel="name" placeholder="Select Students" className="w-full md:w-20rem" />
                                                            </div>
                                                            <div className='w-48 flex-none'>     
                                                                <MultiSelect value={this.state.selectedSubjects} onChange={(e) => this.handleSelectSubject(e.value)} options={this.state.subjects} optionLabel="label" placeholder="Select Subjects" className="w-full md:w-20rem" />
                                                            </div>
                                                            <div className='w-auto grow'></div>
                                                            <div className='w-48 flex-none'>
                                                                <div className="inline-flex rounded-md shadow-sm" role="group">
                                                                    <button type="button"  disabled={this.state.timePeriod === 'daily'} onClick={(e) => this.toggleTimePeriod()} className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                                                        Daily
                                                                    </button>
                                                                    <button type="button" disabled={this.state.timePeriod === 'monthly'} onClick={(e) => this.toggleTimePeriod()} className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                                                        Monthly
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className='w-auto flex-none'>
                                                                <Calendar value={[m(this.state.startDate).toDate(), m(this.state.endDate).toDate()]} onChange={(e) => this.setDate(e.value)} selectionMode="range" readOnlyInput hideOnRangeSelection showIcon/>
                                                            </div>
                                                            {/*<div className='w-auto flex-none'>
                                                                <button type="button" onClick={() => this.getSchedule()}className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                                                     Go
                                                                </button>
                                                            </div>*/}
                                                    <div className='relative flex-none'>
                                                        <div ref={this.wrapperRef} className='w-full py-2'>
                                                            <div className='w-full'>
                                                                <div
                                                                    className='w-full inline-block text-left px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-8 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white'
                                                                >
                                                                    <div className='w-full flex flex-row gap-3 items-center'>
                                                                        <div className='none'><CalendarIcon size='medium' /></div>
                                                                        <div onClick={() => this.setState({ showStartDate: !this.state.showStartDate, showEndDate: false, showDatesMenu: false })}
                                                                            className='flex-grow font-semibold underline underline-offset-4 hover:cursor-pointer'>{`${m(this.state.eventDay).format('MMMM YYYY')}`}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {this.state.showStartDate &&
                                                                <div className='absolute z-10 left-0 mt-1 origin-top-left dark:bg-gray-800 rounded-md'>
                                                                    <DatePicker date={this.state.eventDay} cb={(date: string) => this.setDay('startDate', date)} month/>
                                                                </div>
                                                            }
                                                            
                                                        </div>
                                                    </div>
                                                    <div className='w-full sm:w-auto flex-none flex flex-row justify-end'>
                                                        <button type="button" onClick={() => this.toggleAddEvent()} className="w-full sm:w-auto px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                                            Add To Schedule
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                    <Fetch key={requestHash} sdk={this.sdk} method={this.sdk.getFamilySchedule} params={[startDate, endDate, students]}>
                                                    {(data: any) => (
                                                        <div className='w-full'>
                                                            {this.makeSchedule(data)}
                                                        </div>
                    
                                                    )}
                                                </Fetch>

                </div>

            </Main>
        </div>       
        )
    }
}

export default Schedule